import { render, staticRenderFns } from "./ZimbraMailWizard.vue?vue&type=template&id=24b70910&"
import script from "./ZimbraMailWizard.vue?vue&type=script&lang=js&"
export * from "./ZimbraMailWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports